import React, { useEffect, useRef, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import { getInvoices } from "../helpers/Invoices";
import { Link, useParams } from "react-router-dom";
import { format } from "../helpers/Currency";
import Pagination from "../components/Pagination";
import { getProduct, updateAttributes } from "../helpers/Products";
import { useForm } from "react-hook-form";
import Loading from "../components/Loading";
import AddAmazon from "../components/AddAmazon";
import Input from "../components/Input";
import { Tabs } from "../frontend/components/Tabs";
import { search } from "../helpers/Attributes";
import { refresh } from "../helpers/ProductRefresh";


export default function Product() {
    const { appState } = useAppState();
    const { id } = useParams();
    const { register, handleSubmit } = useForm();
    const [product, setProduct] = useState<any>(null)
    const abortController = useRef<AbortController>();

    const [attributeValues, setAttributeValues] = useState<any>([]);

    const productRefresh = (productStoreId) => {
        refresh(productStoreId).then((result) => {
            console.log(result)
        })
    }

    useEffect(() => {
        if (id) {
            getProduct(parseInt(id)).then((result) => {
                setProduct(result)
            })

            search(parseInt(id)).then((data) => {
                setAttributeValues(data)
            })
        }
    }, [id])


    if (product === null) {
        return <Loading />;
    }

    const onSubmitAttributes = handleSubmit((values) => {
        // console.log(values)
        updateAttributes(
            product.id,
            values
        )
    });

    const handleAmazonAdding = (amazonStoreProduct) => {
        setProduct((prev) => {
            return {
                ...prev,
                storeProducts: [
                    ...prev.storeProducts,
                    amazonStoreProduct
                ]
            }
        })
    }

    let hasAmazon = false;

    return (
        <>
            <form onSubmit={onSubmitAttributes} className="mb-20">

                <div className="flex justify-between items-center">
                    <div className="">
                        <h1 className="text-xl">{product.name}</h1>
                    </div>
                </div>
                {/* <div className="mt-3 p-3 flex flex-col gap-y-5 rounded bg-white">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Basic information</h3>
                </div > */}
                <div className="mt-3 p-6 flex flex-col gap-y-5 rounded bg-white">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Details</h3>
                    <div className="flex flex-col gap-y-2">
                        <div className="flex flex-col">
                            <label>Name</label>
                            <input
                                className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                {...register('name')}
                                defaultValue={product.name}
                                placeholder="Name"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label>SKU</label>
                            <input
                                className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                {...register('sku')}
                                defaultValue={product.sku}
                                placeholder="SKU"
                            />
                        </div>
                        <div className="flex flex-col">
                            <label>Short Description</label>
                            <input
                                className="form-input border-1 px-3 py-2 block w-full border-gray-300 rounded-md shadow-sm focus:ring-sky-500 focus:border-sky-500 sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                                {...register('shortDescription')}
                                defaultValue={product.shortDescription}
                                placeholder="Short Description"
                            />
                        </div>
                    </div>
                </div>
                <div className="mt-3 p-6 flex flex-col gap-y-5 rounded bg-white">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Options</h3>
                    <ul className="flex flex-col space-y-2">
                        {product.storeProducts.map((productStore) => {
                            if (productStore.store.name === 'Amazon') {
                                hasAmazon = true;
                            }

                            return (
                                <li>
                                    <div>
                                        <a className="text-blue-500" href={productStore.url}>{productStore.store.name} {productStore.marketplace ? 'Marketplace' : null}</a> <span> - </span>
                                        {productStore.available ? format(productStore.price.sale_price / 100, 'usd') : 'not available'}

                                        <div><button onClick={() => { productRefresh(productStore.id) }}>Refresh</button></div>
                                    </div>
                                </li>
                            )
                        })}
                    </ul>

                    {hasAmazon ? null : (
                        <AddAmazon productId={product.id} onCallback={handleAmazonAdding} />
                    )}
                </div>

                <div id="attributes" className="mt-3 p-6 flex flex-col gap-y-5 rounded bg-white">
                    <h3 className="text-lg font-medium leading-6 text-gray-900">Attributes</h3>
                    <div className="flex flex-col gap-y-2">
                        {product.categories[0] ? product.categories[0].attributes.map((attribute) => {
                            return (
                                <div className="flex flex-col">
                                    <label>{attribute.name}</label>
                                    <input
                                        list={`attribute-${attribute.id}-options`}
                                        {...register(`attribute-${attribute.id}`)}
                                        defaultValue={product.attributes[attribute.id]}
                                        placeholder={attribute.name}
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                                    />

                                    <datalist id={`attribute-${attribute.id}-options`}>
                                        {attributeValues[attribute.id] ? attributeValues[attribute.id].map((value) => {
                                            return <option key={attribute.id} value={value} />
                                        }) : null}
                                    </datalist>

                                    {/* <Input
                                        {...register(`attribute-${attribute.id}`)}
                                        defaultValue={product.attributes[attribute.id]}
                                        placeholder={attribute.name}
                                    /> */}
                                </div>
                            )
                        }) : null}
                    </div>
                </div>
                <div className="fixed bottom-0 left-0 right-0 z-40 p-6 border-t border-gray-100 bg-white/75">
                    <div className="flex gap-2 justify-end">
                        <a
                            className="rounded-md bg-gray-500 px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                            href={`https://pricehunt.ca/products/${product.alias}`}
                        >
                            Link
                        </a>
                        <button
                            className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            type="submit"
                        >
                            Save
                        </button>
                    </div>

                </div>
            </form>

        </>
    );
}
